import { nonFeaturedGameMaps } from './FeaturedContentDataTypes.ts';
import { RoomSettingConstants, ModeSettingEnum } from '@colonist/game-base-types';
export class GameSorter {
    sort(gameContainerList, userKarma) {
        const gameContainerListClone = [
            ...gameContainerList
        ];
        if (userKarma == undefined) return this.sortGameList(gameContainerListClone);
        const eligibleGames = gameContainerListClone.filter((gameContainer)=>userKarma >= gameContainer.minimumKarma);
        const ineligibleGames = gameContainerListClone.filter((gameContainer)=>userKarma < gameContainer.minimumKarma);
        const sortedEligibleGames = this.sortGameList(eligibleGames);
        const sortedIneligibleGames = this.sortGameList(ineligibleGames);
        const allSortedGames = sortedEligibleGames.concat(sortedIneligibleGames);
        return allSortedGames;
    }
    sortGameList(gameContainerList) {
        const gameContainerListClone = [
            ...gameContainerList
        ];
        const sortedList = gameContainerListClone.sort((previousContainer, nextContainer)=>this.getScore(nextContainer) - this.getScore(previousContainer));
        return sortedList;
    }
    getScore(gameContainer) {
        let score = 0;
        score += this.getNoTrollsScore(gameContainer);
        score += this.getModeScore(gameContainer);
        score += this.getMapScore(gameContainer);
        score += this.getPlayerCountScore(gameContainer);
        return score;
    }
    getNoTrollsScore(gameContainer) {
        const isNoTrollsGame = gameContainer.minimumKarma != RoomSettingConstants.DEFAULT_KARMA_THRESHOLD;
        if (isNoTrollsGame) return this.NO_TROLLS_GAME_STRENGTH;
        return 0;
    }
    getModeScore(gameContainer) {
        const modeSetting = gameContainer.gameModeSetting;
        return GameSorter.getModePriority(modeSetting) * this.MODE_PRIORITY_STRENGTH;
    }
    getMapScore(gameContainer) {
        const isMapFeatured = !nonFeaturedGameMaps.has(gameContainer.gameMapSetting);
        if (isMapFeatured) return this.MAP_PRIORITY_STRENGTH;
        return 0;
    }
    getPlayerCountScore(gameContainer) {
        const activePlayerCount = gameContainer.players.length;
        const score = activePlayerCount / gameContainer.maxPlayers;
        return score < 1 ? score * this.PLAYER_COUNT_PRIORITY_STRENGTH : this.PLAYER_COUNT_PRIORITY_PENALTY;
    }
    static getModePriority(modeSetting) {
        switch(modeSetting){
            case ModeSettingEnum.ColonistRush4P:
                return 5;
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
                return 4;
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnights56P:
                return 3;
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.Seafarers56P:
                return 2;
            case ModeSettingEnum.Classic56P:
            case ModeSettingEnum.Classic78P:
                return 1;
            default:
                return 0;
        }
    }
    constructor(){
        this.NO_TROLLS_GAME_STRENGTH = 90;
        this.MODE_PRIORITY_STRENGTH = 30;
        this.MAP_PRIORITY_STRENGTH = 20;
        this.PLAYER_COUNT_PRIORITY_STRENGTH = 10;
        this.PLAYER_COUNT_PRIORITY_PENALTY = -100;
    }
}
